import React, { useEffect } from "react";

export default function useResetForm(method, data, trigger) {
  useEffect(() => {
    method.reset(data);
  }, [trigger]);
}
